import type { GetDelegateTokenResponse } from '@pillar-portal/api-types';

export type ValorCardTokenizationQueryParamsInput = {
    delegateToken: GetDelegateTokenResponse;
    normalizedPan: string;
    normalizedExpiryDate: string;
};

export const buildValorCardTokenizationQueryParams = (
    input: ValorCardTokenizationQueryParamsInput
): URLSearchParams =>
    new URLSearchParams({
        epi: input.delegateToken.epi,
        txn_type: 'cardToken',
        client_token: input.delegateToken.client_token,
        pan: input.normalizedPan,
        expirydate: input.normalizedExpiryDate,
        cctoken: '',
    });
